import { Container } from "@mui/material";
import PortfolioCard from "./Components/PortfolioCard";
import PortfolioTypeTabs from "./Components/PortfolioTypeTabs";
import DateSort from "./Components/PortfolioCard/Components/DateSort";
import { PORTFOLIO_TYPES } from "./Components/constants";
import PortfolioTradeTable from "./Components/PortfolioTradeTable";
import { useSearchParams } from "react-router-dom";
import PortfolioInvestmentTable from "./Components/PortfolioInvestmentTable";

function Portfolio() {
  const [searchParams] = useSearchParams();
  const portfolioType = +searchParams.get("portfolioType") || 0;

  return (
    <Container maxWidth="100%">
      <PortfolioCard />

      <DateSort />

      <PortfolioTypeTabs />

      {portfolioType === PORTFOLIO_TYPES.trade.key && <PortfolioTradeTable />}
      {portfolioType === PORTFOLIO_TYPES.investment.key && (
        <PortfolioInvestmentTable />
      )}
    </Container>
  );
}

export default Portfolio;
